export default __webpack_public_path__ + "static/media/science.f9b923be6d5235922e544ac117438ff0.svg";